var React = require('react');

function Contacts (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Call"},React.createElement("path",{"id":"Union","d":"M14.885 15.8486C13.2564 17.4772 9.08569 15.9469 5.56939 12.4306C2.0531 8.91432 0.522826 4.74356 2.15142 3.11496L3.22373 2.04265C3.964 1.30238 5.18379 1.32195 5.9482 2.08636L7.6091 3.74727C8.37352 4.51168 8.39308 5.73147 7.65281 6.47174L7.42249 6.70206C7.02281 7.10174 6.98371 7.74651 7.35509 8.19656C7.71331 8.63066 8.0995 9.06304 8.51823 9.48177C8.93696 9.9005 9.36934 10.2867 9.80344 10.6449C10.2535 11.0163 10.8983 10.9772 11.2979 10.5775L11.5283 10.3472C12.2685 9.60692 13.4883 9.62648 14.2527 10.3909L15.9136 12.0518C16.6781 12.8162 16.6976 14.036 15.9573 14.7763L14.885 15.8486Z","stroke":"#121212","strokeWidth":"1.5"})));
}

Contacts.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Contacts;

Contacts.default = Contacts;
